import axios from "axios";

let proxy = {
    proxyUrl: process.env.REACT_APP_SERVER_URL,
    getUrl: function (url) {
        return this.proxyUrl + url;
    },
    getConf: function (conf) {
        if (conf === null || typeof conf === "undefined")
            conf = {}
        conf.withCredentials = true;
        return conf;
    },
    put: function (url, data, conf) {
        url = this.getUrl(url)
        return axios.put(url, data, this.getConf(conf))
    },
    delete: function (url, conf) {
        url = this.getUrl(url)
        return axios.delete(url, this.getConf(conf))
    },
    post: function (url, data, conf) {
        url = this.getUrl(url)
        return axios.post(url, data, this.getConf(conf))
    },
    get: function (url, conf) {
        url = this.getUrl(url)
        return axios.get(url, this.getConf(conf))
    }
}
export default proxy;